import { createStore } from 'vuex'
import { dashBoard } from "./dashboard/index"
import  { communications } from "./communications/index"
import { patients } from "./patients/index"
import { common } from "./common/index"
import { counterCards } from "./counter-cards/index"
import { careCoordinator } from "./careCoordinator/index"
import { careCoordinatorSummary } from "./careCoordinatorSummary/index"
import { tasks } from "./tasks/index"
import { globalCodes } from "./globalCodes/index"
import { rolesAndPermissions } from "./rolesAndPermissions/index"
import { inventory } from "./inventory/index"
import { appointment } from "./appointment/index"
import { authentication } from "./authentication/index"
import { notes } from "./notes/index"
import { thresholds } from "./thresholds/index"
import { timeLogs } from "./timeLogs/index"
import { timeLogReport } from "./timeLogReport/index"
import { timeLogApproval } from "./timeLogApproval/index"
import { careTeam } from "./careTeam/index"
import { programs } from "./programs/index"
import { cptCodes } from "./cptCodes/index"
import { carePlan } from "./carePlan/index"
import {screenPermissions} from "./screenPermissions/index"
import {provider} from "./provider/index"
import { videoCall } from "./videoCall/index"
import { flags } from "./flags/index"
import { password } from "./password/index"
import createPersistedState from "vuex-persistedstate";
import { errorLogWithDeviceInfo} from "./errorLogWithDeviceInfo"
import { businessDashboard } from "./businessDashboard/index"
import { clinicalDashboard } from "./clinicalDashboard/index"
import { referral } from "./referral/index"
import {escalations} from "./escalations/index"
import {reports} from "./reports/index"
import {unprocessedCommunications} from "./unprocessedCommunications/index"
import {bugReport} from "./bugReport/index"
export default createStore({
  modules: {
    dashBoard,
    communications,
    patients,
    counterCards,
    common,
    careCoordinator,
    careCoordinatorSummary,
    tasks,
    globalCodes,
    rolesAndPermissions,
    inventory,
    appointment,
    authentication,
    notes,
    timeLogs,
    timeLogReport,
    thresholds,
    careTeam,
    programs,
    cptCodes,
    carePlan,
    videoCall,
    provider,
    flags,
    password,
    screenPermissions,
    errorLogWithDeviceInfo,
    businessDashboard,
    clinicalDashboard,
    referral,
    escalations,
    reports,
    timeLogApproval,
    unprocessedCommunications,
    bugReport
  },
  plugins: [ createPersistedState({
    reducer(state) {
   
    return {
      token: state.authentication.token
      }
    }
  })]
})
